import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from './pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const PaymentRequisitionSummaryPdf = () => {
    const { commaFormat } = figureFormatter();
    const { getHeader } = pdfHeaderFooter();

    const exportToPDF = (company, data) => {
        const docDefinition = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            header: (currentPage) => {
                if (currentPage === 1) {
                    return getHeader(company);
                }
                return {
                    text: company.name,
                    alignment: 'center',
                    fontSize: 12,
                    margin: [0, 20, 0, 0]
                };
            },
            footer: (currentPage, pageCount) => {
                return {
                    columns: [
                        {
                            stack: [
                                { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 100, y2: 0, lineWidth: 0.5 }] },
                                { text: 'Prepared By', bold: true, margin: [0, 5, 0, 0] }
                            ],
                            alignment: 'center'
                        },
                        {
                            stack: [
                                { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 100, y2: 0, lineWidth: 0.5 }] },
                                { text: 'Reviewed By', bold: true, margin: [0, 5, 0, 0] }
                            ],
                            alignment: 'center'
                        },
                        {
                            stack: [
                                { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 100, y2: 0, lineWidth: 0.5 }] },
                                { text: 'Approved By', bold: true, margin: [0, 5, 0, 0] }
                            ],
                            alignment: 'center'
                        }
                    ],
                    margin: [30, 20, 30, 0]
                };
            },
            content: [
                {
                    text: 'Payment Requisition Summary',
                    fontSize: 14,
                    bold: true,
                    alignment: 'center',
                    margin: [0, 0, 0, 15]
                },
                {
                    columns: [
                        {
                            width: '40%',
                            stack: [
                                { text: `Total Number of Vouchers: ${data.total_vouchers}`, margin: [0, 2] },
                                { text: `Total Number of Cheque: ${data.total_cheques}`, margin: [0, 2] },
                                { text: `Total Amount: ${commaFormat(data.grand_total)}`, margin: [0, 2] }
                            ],
                            fontSize: 10
                        }
                    ],
                    margin: [0, 0, 0, 10]
                },
                ...getTableContent(data.groups)
            ],
            defaultStyle: {
                fontSize: 9,
                color: '#333'
            }
        };

        pdfMake.createPdf(docDefinition).open();
    };

    const getTableContent = (groups) => {
        const content = [];

        groups.forEach(group => {
            content.push({
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: `Payment Method: ${group.account_head_name}`,
                                alignment: 'center',
                                bold: true,
                                fillColor: '#f2f2f2'
                            }
                        ]
                    ]
                },
                margin: [0, 10, 0, 0]
            });

            content.push({
                table: {
                    headerRows: 1,
                    widths: [25, '*', 120, 70, 60, 50, 65],
                    body: [
                        [
                            { text: 'SL', bold: true, alignment: 'center' },
                            { text: 'Payee', bold: true },
                            { text: 'Voucher Description', bold: true },
                            { text: 'Voucher(s) No', bold: true, alignment: 'center' },
                            { text: 'Cheque No', bold: true, alignment: 'center' },
                            { text: 'Cheque Date', bold: true, alignment: 'center' },
                            { text: 'Amount', bold: true, alignment: 'right' }
                        ],
                        ...group.items.map((item, index) => [
                            { text: index + 1, alignment: 'center' },
                            { text: item.payee || '' },
                            { text: item.voucher_descriptions || '', fontSize: 8 },
                            { text: item.voucher_nos || '', alignment: 'center', fontSize: 8 },
                            { text: item.cheque_no || '', alignment: 'center' },
                            { text: item.cheque_date || '', alignment: 'center' },
                            { text: commaFormat(item.amount), alignment: 'right' }
                        ]),
                        [
                            { text: 'TOTAL', bold: true, colSpan: 6, alignment: 'left' },
                            {}, {}, {}, {}, {},
                            { text: commaFormat(group.sub_total), bold: true, alignment: 'right' }
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 0.5,
                    vLineWidth: () => 0.5,
                }
            });
        });

        if (groups.length > 0) {
            content.push({
                table: {
                    widths: ['*', 65],
                    body: [
                        [
                            { text: 'GRAND TOTAL', bold: true, alignment: 'left' },
                            { text: commaFormat(groups.reduce((sum, g) => sum + g.sub_total, 0)), bold: true, alignment: 'right' }
                        ]
                    ]
                },
                margin: [0, 15, 0, 0]
            });
        }

        return content;
    };

    return {
        exportToPDF
    };
};

export default PaymentRequisitionSummaryPdf;
